import { DialogRef } from '@angular/cdk/dialog';
import { type Provider } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { fn } from '@storybook/test';
import { of } from 'rxjs';
import { BasicDialogService } from '../basic-dialog.service';
import { DYNAMIC_COMPONENT_DATA } from '../dynamic-component/dynamic-component.component';

/**
 * Provides a consistent set of providers for testing standalone Angular components.
 * This ensures all standalone components can be tested with the same baseline configuration,
 * reducing boilerplate and ensuring consistent test behavior.
 *
 * @example
 * ```typescript
 * TestBed.configureTestingModule({
 *   imports: [MyStandaloneComponent],
 *   providers: [...STANDALONE_COMPONENT_TEST_PROVIDERS],
 * });
 * ```
 */
export const STANDALONE_COMPONENT_TEST_PROVIDERS: Provider[] = [
  provideNoopAnimations(),
  { provide: MAT_DIALOG_DATA, useValue: {} },
  {
    provide: MatDialogRef,
    useValue: {
      close: () => fn(),
      afterClosed: () => of(undefined),
    },
  },
  { provide: DYNAMIC_COMPONENT_DATA, useValue: {} },
  {
    provide: BasicDialogService,
    useValue: {
      confirm: () => Promise.resolve(true),
      open: () => ({ afterClosed: () => of(undefined) }),
      prompt: () => Promise.resolve('New Name'),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      connected: () => ({}) as DialogRef<any, any>,
    },
  },
];
